import './App.css';
import { useEffect, useState } from "react"
import Layout from './components/layout/Layout';
import { BrowserRouter, Routes, Route } from 'react-router'
import Nodes from './routes/administration/nodes/Nodes';
import BasicReport from './routes/basicreport/basicReport';

import GlobalScenario from './routes/administration/global-scenario-administration/GlobalScenario';
import { loginRequest } from "./authProvider";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { TokenService } from './services/TokenService';
import { AuthorizationService } from './services/AuthorizationService';
import { SignInButton } from "./components/layout/SignInButton";
import ReportMapping from './routes/administration/report-mapping/ReportMapping';
import Upload from './routes/data/upload/Upload';
import Scenarios from './routes/data/scenarios/Scenarios';
import ReportingStructure from './routes/data/reporting-structure/ReportingStructure';
import Mitigations from './routes/data/mitigations/Mitigations';
import DataCorrections from './routes/data/data-corrections/DataCorrections';
import ResultsAndComments from './routes/data/results-and-comments/ResultsAndComments';
import LSPProfile from './routes/reports/lspprofile/lspProfile';
import LSPProfileExport from './routes/reports/lspprofile/lspProfileExport';

function App() {
    const [profileLoaded, setProfileLoaded] = useState(false);

    return (
        <BrowserRouter>
            <UnauthenticatedTemplate>
            <div className='header'>
                <div style={{ "justifyContent" : "center"}} className='header-top'>
                    <SignInButton />
                </div>
            </div>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                <ProfileContent onLoaded={() => setProfileLoaded(true)} />
                {profileLoaded ? (
                <Routes>
                    <Route  index path='/' element={<Layout/>}/>
                    <Route path='LST' element={<Layout />}>
                        <Route path='AdminPages'>
                            <Route path='AccountMapping' element={<AuthorizationService.RenderIfAdmin><BasicReport controllerName='AccountMapping' pageTitle='Account mapping administration' excelFileName='AccountMappingTemplate.xlsx' hideTable='true' /></AuthorizationService.RenderIfAdmin>} tableConfig={false} />
                            <Route path='Nodes' element={<AuthorizationService.RenderIfAdmin><Nodes /></AuthorizationService.RenderIfAdmin>} />
                            <Route path='ReportMapping' element={<AuthorizationService.RenderIfAdmin>< ReportMapping /></AuthorizationService.RenderIfAdmin>} />
                            <Route path='GlobalScenario' element={<AuthorizationService.RenderIfAdmin><GlobalScenario /></AuthorizationService.RenderIfAdmin>} />
                            <Route path='ReportProcessLog' element={<AuthorizationService.RenderIfAdmin><BasicReport controllerName='ReportProcessLog' pageTitle='Process log' excelFileName='ProcessLog.xlsx' /></AuthorizationService.RenderIfAdmin>} />
                            <Route path='ReportUsers' element={<AuthorizationService.RenderIfAdmin><BasicReport controllerName='ReportUser' pageTitle='Report User administration' excelFileName='ReportUser.xlsx' /></AuthorizationService.RenderIfAdmin>} />

                        </Route>
                        <Route path='Data'>
                            <Route path='Scenarios' element={<AuthorizationService.RenderIfSubmitter><Scenarios /></AuthorizationService.RenderIfSubmitter>} />
                            <Route path='ReportingStructure' element={<AuthorizationService.RenderIfSubmitter><ReportingStructure /> </AuthorizationService.RenderIfSubmitter>} />
                            <Route path='UploadAccountMapping' element={<AuthorizationService.RenderIfSubmitter><Upload source='Man_AccMap' pageTitle='Upload account mapping'  /></AuthorizationService.RenderIfSubmitter>}  />
                            <Route path='UploadScenarios' element={<AuthorizationService.RenderIfSubmitter><Upload source='Man_Scenario' pageTitle='Upload scenarios' /></AuthorizationService.RenderIfSubmitter>}  />
                            <Route path='UploadCorrections' element={<AuthorizationService.RenderIfSubmitter><Upload source='Man_Correction' pageTitle='Upload corrections' /></AuthorizationService.RenderIfSubmitter>}  />
                            <Route path='UploadMitigations' element={<AuthorizationService.RenderIfSubmitter><Upload source='Man_Mitigation' pageTitle='Upload mitigations' /></AuthorizationService.RenderIfSubmitter>} />
                            <Route path='ResultsAndComments' element={<AuthorizationService.RenderIfSubmitter><ResultsAndComments /></AuthorizationService.RenderIfSubmitter>} />
                            <Route path='UploadGlobalScenarios' element={<AuthorizationService.RenderIfSubmitter><Upload source='Man_GlobScen' pageTitle='Upload global scenarios' /></AuthorizationService.RenderIfSubmitter>} />
                            <Route path='UploadReportMapping' element={<AuthorizationService.RenderIfSubmitter><Upload source='Man_RepMap' pageTitle='Upload report mapping' /></AuthorizationService.RenderIfSubmitter>} />
                            <Route path='Mitigations' element={<AuthorizationService.RenderIfSubmitter><Mitigations /></AuthorizationService.RenderIfSubmitter>}  />
                            <Route path='DataCorrections' element={<AuthorizationService.RenderIfSubmitter><DataCorrections /></AuthorizationService.RenderIfSubmitter>}  />
                        </Route>
                        <Route path='Reports'>
                            <Route path='LSPProfile' element={<AuthorizationService.RenderIfViewer><LSPProfile pageTitle='LSP Profile' usePagination={true} /></AuthorizationService.RenderIfViewer>} />
                            <Route path='LSPProfileExport' element={<AuthorizationService.RenderIfViewer><LSPProfileExport pageTitle='Export LSP Profile' usePagination={true} /></AuthorizationService.RenderIfViewer>} />

                            <Route path='DNBProfile' element={<AuthorizationService.RenderIfViewer><BasicReport controllerName='DNBProfile' pageTitle='DNB Profile' usePagination={true} /></AuthorizationService.RenderIfViewer>} />
                            <Route path='AccountCalculation' element={<AuthorizationService.RenderIfViewer><BasicReport controllerName='AccountCalculation' pageTitle='Account Calculation' excelFileName='AccountStress.xlsx' usePagination={true} /></AuthorizationService.RenderIfViewer>} />
                            <Route path='LSTOverview' element={<AuthorizationService.RenderIfViewer><BasicReport controllerName='LSTOverview' pageTitle='LST Overview' excelFileName='LstOverview.xlsx' usePagination={true} /></AuthorizationService.RenderIfViewer>} />
                            <Route path='NodeOverview' element={<AuthorizationService.RenderIfViewer><BasicReport controllerName='NodeOverview' pageTitle='Node Overview' excelFileName='NodeOverview.xlsx' usePagination={true} /></AuthorizationService.RenderIfViewer>} />
                            <Route path='Tagetik5028' element={<AuthorizationService.RenderIfViewer><BasicReport controllerName='Tagetik5028' pageTitle='Tagetik 5028' excelFileName='Tagetik5028.xlsx' usePagination={false} /></AuthorizationService.RenderIfViewer>} />
                        </Route>
                    </Route>
                    </Routes>
                ) : (
                    <div></div>
                )}
            </AuthenticatedTemplate>
        </BrowserRouter>
  );
}

function ProfileContent({ onLoaded }) {
    const { instance, accounts } = useMsal();
    const scope = process.env.REACT_APP_ACCESS_API;

    const request = {
        ...loginRequest,
        account: accounts[0],
        scopes: [scope]
    };

    // Silently acquires an access token which is then attached to a request for Microsoft Graph data
    acquireToken(instance, request, { onLoaded });

    useEffect(() => {
        const interval = setInterval(() => {
            //profile should not be loaded when the page is not refreshing and routine to check/refresh token every 5 minutes.
            acquireToken(instance, request, { onLoaded }, false);
        }, 300000);

        return () => clearInterval(interval);
    });
};

function acquireToken(instance, request, { onLoaded }, shouldProfileLoad = true) {
    const currentISODate = new Date().toISOString();
    const user = TokenService.getUser();

    if (user === null || user.accessToken === null || user.accessToken === "" || currentISODate >= user.expiresOn) {
        instance.acquireTokenSilent(request)
            .then(response => {
                // save the user to the local storage
                TokenService.saveUser(response);

                //set the active account to the instanance so that we can get list of groups using graph api
                instance.setActiveAccount(response.account);
            })
            .catch(error => console.error("Error acquiring token or fetching groups:", error));

        // get all the accounts if above is not working
        const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
            instance.setActiveAccount(accounts[0]); // Set the first available account
        }

        const requestGraph = {
            scopes: ["https://graph.microsoft.com/.default"],
            account: instance.getActiveAccount()
        };

        instance.acquireTokenSilent(requestGraph)
            .then(response => fetchAllGroups(response.accessToken))
            .then(groupIds => {
                TokenService.saveUserGroups(groupIds);
                onLoaded(); // Without this links are not visible at first when user is logged in. We need to refresh the page for the links to visible. So this will work as profile is loaded and not routes can be visible. 
            }
            )
            .catch(error => {
                console.error("Error:", error);
            });
    } else if (shouldProfileLoad) {
        onLoaded();
    }
}

// Function to fetch all groups (handles pagination)
async function fetchAllGroups(accessToken) {
    let groupIds = [];
    let url = "https://graph.microsoft.com/v1.0/me/memberOf?$top=999&$count=true";
   // let url = "https://graph.microsoft.com/v1.0/users/{userid}/memberOf"
   // let url = "https://graph.microsoft.com/v1.0/users/{userid}/memberOf"
    
    while (url) {
        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
                ConsistencyLevel: "eventual" // Required for large datasets
            }
        });

        if (!response.ok) {
            throw new Error("Failed to fetch groups: " + await response.text());
        }

        const data = await response.json();
        groupIds = groupIds.concat(data.value.map(group => group.id));

        url = data["@odata.nextLink"] || null; // Get next page URL
    }

    return groupIds;
}

export default App;